import React from "react";
import { TableRow, TableCell, Typography } from "@material-ui/core";
import { DPTable, DPErrorMessage, DPComponentLoader, DPTooltip } from "Components/DP";
import { useReportHeaderOptions } from "Components/Shared/Reports/useReportHeaderOpions";
import pretty from "Shared/pretty";
import useStyles from "./styles";
import { usePresettlementExclusionsHook } from "./usePresettlementExclusionsHook";
import UserAdvancedHeadCell from "./UserAdvancedHeadCell/UserAdvancedHeadCell";
import { Header } from "Components/DP/DPTable/DPTable";
import NetEarningsReportedHeadCell from "./NetEarningsReportedHeadCell/NetEarningsReportedHeadCell";

const ROWS_PER_PAGE = 10;

const PresettlementExclusionsTableHeaders: Header[] = [
  "Name",
  "User ID",
  "Pay Group",
  "DailyPay Status",
  <UserAdvancedHeadCell/>,
  <NetEarningsReportedHeadCell/>,
  "Remainder Payment Amount",
  "Payday Exclusion Reason",
];

export const PresettlementExclusionTable = () => {
  const classes = useStyles();
  const { data, onChangePage, loading, error, page } = usePresettlementExclusionsHook();
  const { visibleHeaders, showPayGroupColumn } = useReportHeaderOptions(
    PresettlementExclusionsTableHeaders
  );

  if (error) return <DPErrorMessage />;

  return (
    <DPTable
      className={classes.table}
      headers={visibleHeaders}
      rowsPerPage={ROWS_PER_PAGE}
      count={data?.totalCount}
      onChangePage={onChangePage}
      loading={loading}
      page={page}
    >
      <DPComponentLoader
        isLoading={loading}
        kind="table"
        awaitComponent={(
          <>
            {data && data.items.map(exclusion => (
              <TableRow hover key={exclusion.id}>
                <TableCell>
                  {
                    pretty.fullName(exclusion.providerAccount.employee.firstName || "", exclusion.providerAccount.employee.lastName || "")
                  }
                </TableCell>
                <TableCell>
                  {exclusion.providerAccount.externalId}
                </TableCell>
                {
                  showPayGroupColumn && (
                    <TableCell>
                      {exclusion.providerAccount.company.payGroup}
                    </TableCell>
                  )
                }
                <TableCell className={classes.statusCell}>
                  {exclusion.providerAccount.employee.userStatus}
                </TableCell>
                <TableCell>
                  {exclusion.payPeriod && pretty.dollar(exclusion.payPeriod.summary.totalTransferredEarlyAmountCents)}
                </TableCell>
                <TableCell>
                  {exclusion.payPeriod && pretty.dollar(exclusion.payPeriod.summary.netEarningsAmountCents)}
                </TableCell>
                <TableCell>
                  {exclusion.payPeriod && pretty.dollar(exclusion.payPeriod.summary.remainderAmountCents)}
                </TableCell>
                <TableCell>
                  <DPTooltip
                    title={(
                      <Typography variant="body1">
                        {exclusion.exclusionNote}
                      </Typography>
                    )}
                  >
                    <div className={classes.reason}>
                      View Details
                    </div>
                  </DPTooltip>
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      />
    </DPTable>
  );
};
